export enum EAnalyticsEvent {
  WALLET_WAS_ADDED = "wallet-was-added",
  PLANET_WAS_TAPPED = "planet-was-tapped",
  USER_SHARED_INVITE_LINK = "user-click-invite-link",
  USER_SHARED_STORY = "user-shared-story",
  USER_POST_STORY = "user-post-story",
  APP_WAS_OPENED = "app-was-opened",
  USER_SHARE_REF_INLINE = "user-share-ref-inline",
  USER_SHARE_STORY_CARD = "user-share-story-card ",
  USER_SHARE_PROFILE = "user-share-profile",
}
